import { useState, useContext } from 'react';
import { Sidebar, Menu, MenuItem, SubMenu, useProSidebar  } from 'react-pro-sidebar';
import classes from "./SideMenuProSidebar.module.scss";
import { MenuContext } from "../../store/menu_context";


import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";

export const SideMenuProSidebar = () => { 
    const { isMenuCollapsed, changeMenuVisibility } = useContext(MenuContext);
    return (
        <Sidebar style={{ height: "100vh", backgroundColor:"rgb(0, 249, 249)" }} collapsed ={isMenuCollapsed}>
            <Menu>
                <SubMenu label="Administration" icon={<MenuOutlinedIcon />} >
                    <MenuItem> Pie charts3 </MenuItem>
                    <MenuItem> Line charts </MenuItem>
                </SubMenu>
                <MenuItem> Documentation </MenuItem>
                <MenuItem> Calendar </MenuItem>
            </Menu>
        </Sidebar>
    )

}